import { Avatar, Tooltip, Typography } from "@mui/material";
import { useMemo } from "react";
import type { WorkbookFilter } from "../../../../api/types/workbookRuns.types";
import { toLabel } from "../../dashboard/utils/withValue";
import { getValidatedDateString } from "../../reporting/utils/dateUtils";

interface Props {
  filter: WorkbookFilter;
}

const WorkbookFilterValue = ({ filter }: Props) => {
  const { firstValue, otherValues } = useMemo(() => {
    if (filter.type === "Table") {
      const keyField = filter.dictionaryLoadSettings?.primaryKeyField ?? "";
      return {
        firstValue: filter.selectedOptions?.[0] ? toLabel(filter.selectedOptions?.[0].properties[keyField]) : "",
        otherValues: filter.selectedOptions?.slice(1).map((option) => toLabel(option.properties[keyField])),
      };
    }
    if (filter.type === "Date") {
      return {
        firstValue: toLabel(getValidatedDateString(filter.value[0], undefined)),
        otherValues: [],
      };
    }
    return {
      firstValue: "",
      otherValues: [],
    };
  }, [filter]);

  if (filter.type === "Date") {
    return (
      <Typography variant="body2" noWrap color="textSecondary">
        {firstValue}
      </Typography>
    );
  }
  if (filter.type === "Table") {
    return (
      <>
        <Typography variant="body2" noWrap color="textSecondary">
          {firstValue}
        </Typography>
        {otherValues && otherValues.length > 0 && (
          <Tooltip arrow title={<div style={{ whiteSpace: "pre-line" }}>{otherValues.join("\n")}</div>}>
            <Avatar sx={{ width: 24, height: 24, fontSize: 12 }}>{`+${otherValues.length}`}</Avatar>
          </Tooltip>
        )}
      </>
    );
  }
  return null;
};

export default WorkbookFilterValue;
